import { FunctionComponent, useEffect, useRef, useState } from "react";
import commonStyle from "../common.module.css";
import { connect, useDispatch } from "react-redux";
import styles from './Booking.module.css'
import Loading from "../../Components/Loading/Loading";
import axios from "axios";
import { url } from "../../Values/constants";
import { BookingColumns, BookingOMColumns } from "../../Values/tables";
import { themeColors } from "../../Components/theme";
import FormDialog from "./Dialog";
import { showSnackbarAction } from "../../Redux/actions";
import CustomTable from "../../Components/CustomTable/CustomTable";
import TopBar from "../../Components/TopBar/TopBar";
import { useMediaQuery } from "@material-ui/core";

type props = {
  history: any;
  user: any;
  theme: any;
  authToken:any;
};
const Booking: FunctionComponent<props> = ({
  history,
  user,
  theme,
  authToken
}) => {
  const dispatcher = useDispatch();
  const isMobile = useMediaQuery('(max-width: 900px)');
  const [searchQuery, setsearchQuery] = useState("");
  const [bookigDetails, setBookingDetails] = useState<any[]>([]);
  const [allBookingDetails, setAllBookingDetails] = useState<any[]>([]);
  const [reBookingModel, setReBookingModel] = useState<boolean>(false);
  const [load, setLoad] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [columnModal, setColumnModal] = useState(false);
  const hasFetched = useRef(false);
  const [clearFilterTable, setClearFilterTable] = useState(false);

  useEffect(() => {
    if (user && authToken && !hasFetched.current) {
      getAllBooKing();
      hasFetched.current = true;
    }
  }, [user, authToken]);

  useEffect(() => {
    if (searchQuery && searchQuery.trim() !== "") {
      const q = searchQuery.trim().toLowerCase();
      const filtered = allBookingDetails.filter((item: any) =>
        (item.contact_no && item.contact_no.toLowerCase().includes(q)) ||
        (item.customer_name && item.customer_name.toLowerCase().includes(q))
      );
      setBookingDetails(filtered.map((va: any, index: any) => ({ id: index + 1, ...va })));
    } else {
      setBookingDetails(allBookingDetails.map((va: any, index: any) => ({ id: index + 1, ...va })));
    }
  }, [searchQuery, allBookingDetails]);

  const getAllBooKing = async () => {
    let filterData: any[] = [];
    const bodyData = {
      filter: {},
      page: 1,
      pageSize: 40,
      searchString: "",
      sort: {},
      uid: user?.uid || user?.auth_id,
      bookingFilter: {},
      skip: 0,
      limit: 40
    }
    try {
      setLoad(true);
      axios.defaults.headers.common['x-access-token'] =
        authToken
      const getBookingRes = await axios.post(
        url + '/bookings/booking',
        bodyData
      );
      if (getBookingRes?.status == 200) {
        getBookingRes?.data?.map((val: any, index: any) => {
          return filterData.push(
            ...val.bookingDetails?.map((list: any) => {
              return { "organization_id": val.organization_id, "uid": val.uid, "customer_name": val.contactDetails?.customer_name, "contact_owner_email": val.contactDetails?.contact_owner_email, "Contact_Id": val.contactDetails?.contactId, "contact_no": val.contact_no, ...list }
            })
          )
        })
        setAllBookingDetails(filterData);
        setLoad(false);
      }
    }
    catch {
      setLoad(false);
      dispatcher(showSnackbarAction('Please Try Again!!', 'error'));
    }
  }

  const handleOnCellClick = (data: any) => {
      history.push({
        pathname: '/viewBookingDetails',
        state: { "data": data, "key": "view" }
      })
  };

  const handleClearFilter = () => {
    setClearFilterTable(prev => !prev);
  };
  const parentStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark }
  const topBarStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, width: "97%" }

  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: isMobile ? "6%" : "4%", ...parentStyles }}>
        {load === true && <Loading />}
        <div className={commonStyle.topBar} style={{ marginTop: "0px", ...topBarStyles }}>
          <TopBar
            history={history}
            title={"Add Re-Booking"}
            path={""}
            onChange={(val) => setsearchQuery(val)}
            filterText="Status"
            setColumnModal={(data) => setColumnModal(data)}
            showStatusBox={true}
            show={false}
            setReBookingModel={(data) => setReBookingModel(data)}
            clearFilter={handleClearFilter}
          />
        </div>
        <div className={commonStyle.parent} style={{ minHeight: "450px" }}>
          <CustomTable
            tableColumns={user?.profile === "Operation Manager"? BookingOMColumns: BookingColumns}
            tableRows={bookigDetails}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="Booking"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) => setSelectedRowsData(data)}
            setSearchedItem={(val) => setsearchQuery(val)}
            handleOnCellClickBooking={handleOnCellClick} 
            clearFilterTable={clearFilterTable}
          />
        </div>
      </div>
      {reBookingModel && <FormDialog
        openDialog={reBookingModel}
        setOpenDialog={setReBookingModel}
        userDetails={user}
        history={history}
      />}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    theme: state.theme.isLightMode,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    filterObject: state.filter,
    filterSort: state.filterSort,
    refreshContacts: state.refresh.refreshContacts,
    searchString: state.searchItem.contactsSearchString,
    authToken: state.user.authToken,
  };
};

export default connect(mapStateToProps)(Booking);